import { UserModal } from '@/components';
import {
  currentUser as queryCurrentUser,
  customButton,
  menuAuth,
} from '@/services/ant-design-pro/api';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import React, { lazy, Suspense } from 'react';
import { Tag, Dropdown } from 'antd';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import { HomeOutlined, DownOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons';
const isDev = process.env.NODE_ENV === 'development';
import { treeJoinList2 } from './util/fun';
const loginPath = '/homePage';
import * as icons from '@ant-design/icons';
import styles from '@/pages/overview/style.module.css';
import { certificateInfo } from '@/services/ant-design-pro/auth';

const iconsdata: any = icons;

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export const patchClientRoutes = async (data: any) => {
  let { routes } = data;
  const res = await menuAuth({ type: 1 });
  let route = res.data;

  route = route.filter(
    (item: any) => item.menuType !== 'F' && item.menuType !== 'A'
  );
  let list: any[] = [];
  for (const item of route) {
    let Dom: any = null;
    let data: any = {
      path: item.path,
      name: item.menuName,
      menuId: item.menuId,
      icon: <Icon component={iconsdata[item.icon]}></Icon>,
      parentId: item.parentId === '0' ? 'ant-design-pro-layout' : item.parentId,
      meta: {
        content: 'width=device-width, initial-scale=1.0',
      },
    };
    if (item.component && item.component.trim() != '') {
      try {
        Dom = await lazy(() => import('@/pages/' + item.component));
        data.element = (
          <Suspense fallback={<div>Loading...</div>}>
            <Dom></Dom>
          </Suspense>
        );
      } catch (err) {}
    }
    list.push(data);
  }
  route = await treeJoinList2(list);
  const index = routes.findIndex(
    (item: any) => item.id === 'ant-design-pro-layout'
  );
  routes[index].children = [...routes[index].children, ...route];
  localStorage.setItem('reader', 'true');
};
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  authButton?: any;
  UserDetailInfo?: UserInfo.Info;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return msg.data;
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  const token = localStorage.getItem('token');
  if (token === null || token === undefined) {
    return {
      fetchUserInfo,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  if (
    [
      '/homePage',
      '/applyof',
      '/',
      '/agreement',
      '/cloudPhone',
      '/cloudGame',
      '/solution',
      '/about',
    ].includes(location.pathname) &&
    token !== null &&
    token !== undefined
  ) {
    const currentUser = await fetchUserInfo();
    const authButton = await customButton();
    return {
      fetchUserInfo,
      authButton,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  if (
    location.pathname !== loginPath &&
    location.pathname !== '/api' &&
    location.pathname !== '/auth' &&
    location.pathname !== '/homePage' &&
    location.pathname !== '/cloudPhone' &&
    location.pathname !== '/cloudGame' &&
    location.pathname !== '/solution' &&
    location.pathname !== '/about'
  ) {
    const currentUser = await fetchUserInfo();
    const authButton = await customButton();
    const infoData = await certificateInfo();
    return {
      fetchUserInfo,
      authButton,
      currentUser,
      UserDetailInfo: infoData.data,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  return {
    menu: {
      type: 'group',
      defaultOpenAll: true,
      hideMenuWhenCollapsed: true,
      ignoreFlatMenu: false,
      request: async () => {
        const res = await menuAuth({ type: 1 }).then((res) => res.data);
        let route = res.filter(
          (item: any) => item.menuType !== 'F' && item.menuType !== 'A'
        );

        let router = route.map((item: any) => {
          return {
            path: item.path,
            name: item.menuName,
            layout: item.visible === '0',
            menuId: item.menuId,
            parentId: item.parentId,
            icon: <Icon component={iconsdata[item.icon]}></Icon>,
          };
        });
        route = await treeJoinList2(router);
        router = route.filter((item: any) => item.layout);
        return router;
      },
    },
    collapsed: false,
    collapsedButtonRender: false,
    menuFooterRender: false,
    footer: {
      render: () => null, // 完全不渲染 footer
    },
    actionsRender: () => [
      initialState?.UserDetailInfo?.personOrEnterprise === 2 && (
        <Dropdown menu={{ items: [] }}>
          <a className={styles.font_title}>
            {initialState?.UserDetailInfo?.enterpriseName}
            <DownOutlined style={{ marginRight: '24px' }} />
          </a>
        </Dropdown>
      ),
      <a
        href="/document"
        target="_break"
        style={{
          fontSize: '14px',
          color: '#333',
          height: '60px',
          lineHeight: '50px',
        }}
      >
        文档
      </a>,
    ],
    // headerContentRender: () => {
    //   return (<Tag icon={<HomeOutlined />} style={{cursor: 'pointer'}} color="processing" onClick={() => history.push('/overview')}>总览页</Tag>)
    // },
    avatarProps: {
      render: (_, avatarChildren) => {
        return <UserModal></UserModal>;
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.customName,
    },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    // links: isDev
    //   ? [
    //       <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
    //         <LinkOutlined />
    //         <span>OpenAPI 文档</span>
    //       </Link>,
    //     ]
    //   : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {/* {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )} */}
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
};
